<template>
  <onboarding-layout>
    <h1 class="heading sr-only">
      Kwispelcoach
    </h1>

    <ul class="checked-list mt-2 mb-3">
      <li>Ontvang direct tips voor jouw pup of kitten</li>
      <li>Deel foto's en mijlpalen in de app</li>
      <li>Maak elke maand kans op een gratis proefpakket!</li>
    </ul>

    <ul class="buttons-list">
      <li>
        <Button
          component-type="router-link"
          :to="{ name: 'OnboardingPetType' }"
          :show-arrow="false"
        >
          Start met jouw huisdier
        </Button>
      </li>

      <li>
        <Button
          component-type="router-link"
          to="/login"
          type="default"
          :show-arrow="false"
        >
          Ik heb al een account
        </Button>
      </li>
    </ul>

    <div class="powered-by">
      <h4 class="heading">
        Powered By
      </h4>

      <ul class="partner-list">
        <li>
          <a href="https://www.smolke.nl/" target="_blank">
            <img src="../assets/logo-smolke.svg" width="75" alt="Smolke logo">
          </a>
        </li>

        <li>
          <a href="https://www.rodi-petfood.nl/" target="_blank">
            <img src="../assets/logo-rodi.png" width="50" alt="Rodi logo">
          </a>
        </li>

        <li>
          <a href="https://www.yarrah.com/" target="_blank">
            <img src="../assets/logo-yarrah.svg" width="75" alt="Yarrah logo">
          </a>
        </li>
      </ul>
    </div>
  </onboarding-layout>
</template>

<script>
import OnboardingLayout from './Onboarding/OnboardingLayout.vue';
import Button from '../components/Button.vue';

export default {
  name: 'Home',

  components: {
    OnboardingLayout,
    Button,
    //
  },

  created() {
    this.$store.commit('resetLayout');
  },
};
</script>

<style>
.buttons-list li:not(:last-child) {
  margin-bottom: .875rem;
}

.checked-list {
  text-align: left;
  max-width: 21rem;
  margin-left: auto;
  margin-right: auto;
}

.checked-list li {
  padding-left: 1.5rem;
  position: relative;
  margin-bottom: .25rem;
}

.checked-list li:before {
  content: '';
  background: url(../assets/check.svg) no-repeat center center;
  background-size: 100% auto;
  position: absolute;
  top: .125rem;
  left: 0;
  width: 1rem;
  height: 1rem;
}

.logo {
  position: absolute;
  top: -.875rem;
  left: 50%;
  transform: translateX(-50%);
}

.kwispelcoach-logo {
  position: absolute;
  top: 2rem;
  right: 2rem;
  max-width: 12rem;
  margin-top: -1rem;
  margin-left: -.5rem;
}

@media (min-width: 640px) {
  .kwispelcoach-logo {
    top: 3rem;
    right: 6rem;
  }
}

.partner-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  padding: 0.5rem;
  align-items: center;
  justify-items: center;
  max-width: 400px;
  margin: 0 auto;
}

.partner-list li {
  display: flex;
  justify-content: center;
  align-items: center;
}

.partner-list img {
  max-width: 100%;
  height: auto;
}

.powered-by {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 0 1rem 1rem;
  width: 100%;
  border-radius: 2rem 2rem 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.powered-by .heading {
  margin-bottom: 0.5rem;
  text-align: center;
}

.onboarding-layout {
  padding-bottom: 120px;
}
</style>
